<template>
    <v-container
        fluid
        class="px-4"
        v-if="wristband">

        <v-row>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.wristbandDetails.wristbandId')"/>
                <div>
                    {{ wristband.GiftCardNo }}
                </div>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.wristbandDetails.activationDate')"/>

                <div>
                    {{ $util.getDDMMYYYYHHSSDateFormat(new Date(wristband.createdAt).getTime() + (60*420*1000)) }}
                </div>
            </v-col>

            <hr class="full-width ma-4">

            <v-col cols="12">
                <span
                    class="subtitle-2 font-weight-bold mr-2"
                    v-html="$t('andamandaPay.wristbandDetails.currentBalance')"/>
                <icon
                    value="custom_coin"
                    size="18px"/>

                <br/>

                <v-row>
                    <v-col
                        cols="5">
                        <v-text-field
                            outlined
                            readonly
                            hide-details
                            height="40px"
                            :value="balance"/>
                    </v-col>
                </v-row>
            </v-col>

            <v-col
                cols="12">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('andamandaPay.wristbandDetails.transactionHeader')"/>
            </v-col>

            <v-col
                class="pt-0"
                cols="12">
                <transaction-table
                    disable-sort
                    :items="wristband.transactions"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else></div>
</template>

<script>
import TransactionTable from '@/components/tables/TransactionTable'

export default {
    name: 'WristbandDetailsView',

    components: {
        TransactionTable
    },

    props: {
        wristband: {
            type: Object,
            default: () => null
        }
    },

    computed: {
        balance () {
            return this.wristband?.balance ?? 0
        }
    }
}
</script>

<style lang="scss" scoped></style>
